import getRemainingTime from "../utils/get-remaining-time";
class DateCountDown {
  constructor(element){
    this.container = element;
    this.date = new Date(this.container.dataset.date);
    this.timer = null;

    this.$ = {
      days: document.querySelector('[data-days]'),
      hrs: document.querySelector('[data-hrs]'),
      mins: document.querySelector('[data-mins]'),
      secs: document.querySelector('[data-secs]')
    };

    this.start();
  }

  start() {
    this.timer = setInterval(() => {
      const remaining = getRemainingTime(this.date);

      if(!remaining) {
        this.stop();
        return;
      }

      Object.keys(remaining).forEach(key => 
        remaining[key] = remaining[key].toString().padStart(2, '0')
      );

      this.render(remaining);
    }, 1000);
  }

  stop() {
    clearInterval(this.timer);
  }

  render({ days, hours, minutes, seconds }){
    if( this.$.days ) {
      this.$.days.innerHTML = days;
    }
    
    if( this.$.hrs ) {
      this.$.hrs.innerHTML = hours;
    }

    if( this.$.mins ) {
      this.$.mins.innerHTML = minutes;
    }

    if( this.$.secs ) {
      this.$.secs.innerHTML = seconds;
    }
  }
}

const dateCountDowns = document.querySelectorAll('.js-DateCountDown');
dateCountDowns.forEach(element => new DateCountDown(element) );

export default DateCountDown;